import { IClient, IClientAction } from "../../shared/interfaces/client/IClient";
import { IBaseModel } from "../../shared/interfaces/shared/IBase";
import { IPagination } from "../../shared/interfaces/shared/IPagination";
import { requests } from "../../utils/api/api.service";
import { CLIENT_URL } from "../../utils/api/endpoints";

export const ClientService = {
  get: (pagination: IPagination): Promise<IBaseModel<IClient[]>> =>
    requests.get(CLIENT_URL, pagination),
  getSingle: (id: number): Promise<IClient> =>
    requests.get(`${CLIENT_URL}/${id}`),
  create: (params: IClientAction) => requests.post(CLIENT_URL, params),
  update: (params: IClientAction, id: number) =>
    requests.put(`${CLIENT_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${CLIENT_URL}/${id}`),
};
